import { ExportCsv } from "@material-table/exporters";
import {
  ADD_ROW_POSITION,
  TOOLBAR_BUTTON_ALIGNMENT,
  EXPORT_ALL_DATA,
  COLUMNS_BUTTON,
  ACTIONS_COLUMN_INDEX,
  SEARCH_FIELD_ALIGNMENT,
  LOADING_TYPE,
  EXPORT_AS_CSV_LABEL,
  DEFAULT_FILENAME,
} from "./constants";

const generateOptions = (optionsFromProps, filename) => {
  const options = {
    actionsColumnIndex: ACTIONS_COLUMN_INDEX,
    exportMenu: [
      {
        label: EXPORT_AS_CSV_LABEL,
        exportFunc: (cols, datas) =>
          ExportCsv(cols, datas, filename || DEFAULT_FILENAME),
      },
    ],
    headerStyle: {
      backgroundColor: "#003375",
      color: "rgba(255,255,255,var(--tw-text-opacity))",
      fontWeight: "bold",
    },
    fixedColumns: { left: 0 },
    exportAllData: EXPORT_ALL_DATA,
    columnsButton: COLUMNS_BUTTON,
    loadingType: LOADING_TYPE,
    addRowPosition: ADD_ROW_POSITION,
    searchFieldAlignment: SEARCH_FIELD_ALIGNMENT,
    toolbarButtonAlignment: TOOLBAR_BUTTON_ALIGNMENT,
    ...optionsFromProps,
  };

  return options;
};

export default generateOptions;
